import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Fade,
  Slide,
  CircularProgress,
  ListItemText,
  ListItem,
  Collapse,
  IconButton,
  List,
  Chip,
  Divider,
} from "@mui/material";
import {
  Close as CloseIcon,
  FileDownload,
  AutoAwesome,
  Campaign,
  Delete,
  Info,
  NavigateNext,
  ReportProblem,
  RadioButtonChecked,
  ExpandLess,
  ExpandMore,
  InfoOutlined,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import FolderIcon from "@mui/icons-material/Folder";
import bgsd from "../../assets/bgsd.png";
import { useNavigate } from "react-router-dom";
// import { withTranslation } from "react-google-multi-lang";
// import { translateBulk } from "./translationService";
import { SidebarFixed } from "./ProSidebar";

import { ALLOWED_FILE_FORMATS, BACKEND_BASE_URL } from "../../constants";
import Logo from "../../assets/Logo.svg";
import { useFileContext } from "./FileContext";
import { useLocation } from "react-router-dom";
import CategorySelector from "./CategorySelector";
// import Personas from "./Personas";
import CM from "../../assets/CM.png";
import CPO from "../../assets/CPO.png";
import uploadicon from "../../assets/uploadicon.png";
import {
  SpendDashboardAnalyticsSection,
  SPEND_DASHBOARD_SECTION_MAPPING,
} from "./SpendDashboardAnalyticsSection";
import { Lightbulb } from "lucide-react";

const SpendDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { roleTitle } = location.state || {};
  const [roleTitle, setRoleTitle] = useState("");
  const [file, setFile] = useState(null);
  const [dashboardData, setDashboardData] = useState({
    spend_summary: {
      overall_spend: "",
      yoy_increase_spend: null,
      most_recent_year: "",
      second_most_recent_year: "",
      currency_value: "",
    },
    category_summary: {
      num_l1_categories: 0,
      num_l2_categories: 0,
      contribution_statement: "",
    },
    supplier_summary: {
      total_suppliers: 0,
      top_80_percent_supplier_count: 0,
      yoy_increase_suppliers: null,
      most_recent_year: "",
      second_most_recent_year: "",
    },
  });

  // const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showNewsOverlay, setShowNewsOverlay] = useState(false);
  const [categoryChartData, setCategoryChartData] = useState([]);
  const [categoryChartDataL1, setCategoryChartDataL1] = useState([]);
  const [spendChartData, setSpendChartData] = useState([]);
  const [supplierChartData, setSupplierChartData] = useState(null);
  const [supplierTableData, setSupplierTableData] = useState(null);
  const [categoryInsights, setCategoryInsights] = useState(null);
  const [supplierInsights, setSupplierInsights] = useState(null);
  const [spendInsights, setSpendInsights] = useState([]);
  const [open, setOpen] = useState(false);
  const [clientInsights, setClientInsights] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState("upload spend");
  const [hasAnimated, setHasAnimated] = useState({});
  const [role, setRole] = useState("Head of Direct Procurement");
  const [purpose, setPurpose] = useState(
    "I am looking to negotiate with Suppliers"
  );
  const [showUpload, setShowUpload] = useState(false);
  const [loadingSection, setLoadingSection] = useState(null);
  // const [costStructureData, setCostStructureData] = useState([]);
  // const [utilityData, seUtilityData] = useState([])
  // const [laborData, setLaborData] = useState([])
  const [progress, setProgress] = useState({
    companyDetails: false,
    spendPatterns: false,
    spendSummary: false,
    categorySummary: false,
    supplierSummary: false,
    categorySpend: false,
    topCategories: false,
  });
  const [isTranslated, setIsTranslated] = useState(false);
  const [clientNames, setClientNames] = useState([]);

  // NEW STATES
  const [spendSummary, setSpendSummary] = useState({
    spend_summary: {
      overall_spend: "",
      yoy_increase_spend: null,
      most_recent_year: "",
      second_most_recent_year: "",
      currency_value: "",
    },
  });

  const [categorySummary, setCategorySummary] = useState({
    category_summary: {
      num_l1_categories: null,
      num_l2_categories: null,
      contribution_statement: "",
    },
  });

  const [supplierSummary, setSupplierSummary] = useState({
    supplier_summary: {
      total_suppliers: null,
      top_80_percent_supplier_count: null,
      yoy_increase_suppliers: null,
      most_recent_year: "",
      second_most_recent_year: "",
    },
  });
  const [topCategories, setTopCategories] = useState([]);
  const [topContributors, setTopContributors] = useState({});
  const [costStructure, setCostStructure] = useState({});
  const [demandandSupply, setDemandandSupply] = useState({});
  const [marketSize, setMarketSize] = useState({});
  const [topSuppliers, setTopSuppliers] = useState({});
  const [categoryNews, setCategoryNews] = useState({});
  const [categoryMessages, setCategoryMessages] = useState({});
  const [categorySummaryCS, setCategorySummaryCS] = useState({});
  const [top3CategoriesSup, setTop3CategoriesSup] = useState([]);
  const [topsuppercat, setTopsuppercat] = useState({});
  const [supDandP, setSupDandP] = useState({});
  const [supCustInfo, setSupCustInfo] = useState({});
  const [supplierNews, setSupplierNews] = useState([]);
  const [riskScore, setRiskScore] = useState({});
  const [scoreCommentary, setScoreCommentary] = useState([]);
  const [carbonEmission, setCarbonEmission] = useState({});
  const [revenue, setRevenue] = useState({});
  const [currency, setCurrency] = useState({});
  const [supplierContribution, setSupplierContribution] = useState("");

  const [top10categories, setTop10Categories] = useState([]);
  const [categoryNewsPart1, setCategoryNewsPart1] = useState({});
  const [categoryNewsPart2, setCategoryNewsPart2] = useState({});
  const [categoryNewsPart3, setCategoryNewsPart3] = useState({});
  const [categoryNewsPart4, setCategoryNewsPart4] = useState({});

  const [messagesPart1, setMessagesPart1] = useState({});
  const [messagesPart2, setMessagesPart2] = useState({});
  const [messagesPart3, setMessagesPart3] = useState({});
  const [messagesPart4, setMessagesPart4] = useState({});
  const [top10categoriesForecast, setTop10categoriesForecast] = useState({});

  const [categoryPart1Response, setCategoryPart1Response] = useState({});
  const [carbonTable, setCarbonTable] = useState({});
  const [forecast, setForecast] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [errorDetailsOpen, setErrorDetailsOpen] = useState(false);
  const [largestSpendSubcategory, setLargestSpendSubcategory] = useState("");
  const [seriesData, setSeriesData] = useState([]);
  const [selectedSeriesCode, setSelectedSeriesCode] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [heatmapChartData, setHeatmapChartData] = useState({});

  //  FOR KPDB
  const [kpdbData, setKpdbData] = useState({});
  const [taxonomyFile, setTaxonomyFile] = useState(null);

  const [supplierProData, setSupplierProData] = useState("");

  const [costStructureMovements, setCostStructureMovements] = useState([]);
  const [categoryDict, setCategoryDict] = useState({});

  const [indiSummaries, setIndiSummaries] = useState({});
  const [globalSummaries, setGlobalSummaries] = useState({});

  // CLIENT REVENUE

  const [clientRevenue, setClientRevenue] = useState("");
  const fileContextValue = useFileContext();
  // console.log('fileContextValue is', fileContextValue);
  const { setFilename } = useFileContext();
  // PORTER FORCES

  const [porterForces, setPorterForces] = useState({});
  const [catandSpend, setCatandSpend] = useState({});
  const [marketImplications, setMarketImplications] = useState({});

  // CS Source
  const [csSrc, setCsSrc] = useState({});

  // First, add topMovementsAnalysis to your component's state
  const [topMovementsAnalysis, setTopMovementsAnalysis] = useState({});

  const [topcardCommentary, setTopCardCommentary] = useState({});

  // to show persona screen

  const [showPersonas, setShowPersonas] = useState(false);

  const isUncategorized = useMemo(
    () =>
      uploadError?.error_code === "FILE_UNCATEGORIZED" ||
      errorMessage === "File Uncategorized",
    [uploadError, errorMessage]
  );

  // Subsections for each main section
  const subSectionMapping = {
    spend_overview: ["Spend Overview", "Key Takeaways"],
    category: [
      "Deep Dive",
      "Market Insights",
      "Spend Overview",
      "Price Volatility",
      "Key Insights",
    ],
    supplier: ["Overview", "Deepdive"],
    carbon: [],
  };

  // Initialize state
  const [currentSection, setCurrentSection] = useState(
    SPEND_DASHBOARD_SECTION_MAPPING["Spend Overview"]
  );

  const [currentSubSection, setCurrentSubSection] = useState("Company Details");
  const handleSectionClick = (event, section) => {
    event.preventDefault();
    setCurrentSection(section);
    // Set default subsection when changing sections
    setCurrentSubSection(subSectionMapping[section][0]);
  };

  const handleSubSectionClick = (event, subsection) => {
    event.preventDefault();
    setCurrentSubSection(subsection);
  };

  const handleBreadcrumbClick = (event, section) => {
    event.preventDefault();
    setCurrentSection(section);
    const element = document.getElementById(section);
    if (element) {
      const yOffset = -115; // Adjust this value based on the combined height of AppBar and Breadcrumbs
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
      .print-white {
        color: white !important;
      }
    }
  `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style); // Cleanup when component unmounts
    };
  }, []);

  const handleNext = () => {
    setShowUpload(true);
  };

  const handleSwitchToAnalytics = () => {
    setActiveSection("analytics");
    setProgress({
      companyDetails: false,
      spendPatterns: false,
      spendSummary: false,
      categorySummary: false,
      supplierSummary: false,
      categorySpend: false,
      topCategories: false,
    });
  };

  // deplyment function
  const handleFileUpload = async (event) => {
    // Access categories from the event object
    const categories = event.categories || [];
    console.log("Categories for file upload:", categories);
    console.log("File:", event.target.files[0]);
    setRoleTitle(event.roleTitle);

    const uploadedFile = event.target.files[0];
    if (uploadedFile && uploadedFile.name.endsWith(".csv")) {
      setFile(uploadedFile);
      const formData = new FormData();
      formData.append("file", uploadedFile);

      console.log("event category", event.categories);

      setClientInsights("");
      setDashboardData({
        spend_summary: {
          overall_spend: "",
          yoy_increase_spend: null,
          most_recent_year: "",
          second_most_recent_year: "",
          currency_value: "",
        },
        category_summary: {
          num_l1_categories: 0,
          num_l2_categories: 0,
          contribution_statement: "",
        },
        supplier_summary: {
          total_suppliers: 0,
          top_80_percent_supplier_count: 0,
          yoy_increase_suppliers: null,
          most_recent_year: "",
          second_most_recent_year: "",
        },
      });
      setCategoryInsights(null);
      setCategoryChartData([]);
      setCategoryChartDataL1([]);
      setSupplierChartData(null);
      setSupplierTableData(null);
      setSupplierInsights(null);
      setSpendChartData([]);
      setLoading(true);
      setRiskScore();
      setScoreCommentary([]);
      setRevenue({});
      setCurrency({});
      setSupplierContribution("");

      // new states

      setSpendSummary({
        spend_summary: {
          overall_spend: "",
          yoy_increase_spend: null,
          most_recent_year: "",
          second_most_recent_year: "",
          currency_value: "",
        },
      });
      setCategorySummary({
        category_summary: {
          num_l1_categories: 0,
          num_l2_categories: 0,
          contribution_statement: "",
        },
      });
      setSupplierSummary({
        supplier_summary: {
          total_suppliers: 0,
          top_80_percent_supplier_count: 0,
          yoy_increase_suppliers: null,
          most_recent_year: "",
          second_most_recent_year: "",
        },
      });
      setTopCategories([]);
      setTopContributors({});
      setCostStructure({});
      setDemandandSupply({});
      setMarketSize({});
      setTopSuppliers({});
      setCategoryNews({});
      setCategoryMessages({});
      setCategorySummaryCS({});
      setTop3CategoriesSup([]);
      setTopsuppercat({});
      setSupDandP({});
      setSupCustInfo({});
      setSupplierNews([]);
      setRiskScore({});
      setScoreCommentary({});
      setCarbonEmission({});
      setTop10Categories([]);
      setCategoryNewsPart1({});
      setCategoryNewsPart2({});
      setCategoryNewsPart3({});
      setCategoryNewsPart4({});
      setMessagesPart1({});
      setMessagesPart2({});
      setMessagesPart3({});
      setMessagesPart4({});
      setTop10categoriesForecast({});

      setCategoryPart1Response({});
      setCarbonTable({});
      setForecast({});
      setErrorMessage(null);
      setUploadError(null);
      setErrorDetailsOpen(false);
      setLargestSpendSubcategory("");
      setSeriesData([]);
      setSelectedSeriesCode("");
      setFilteredResults([]);
      setKpdbData({});
      setCostStructureMovements([]);
      setSupplierProData("");
      setCategoryDict({});
      setIndiSummaries({});
      setGlobalSummaries({});
      setClientRevenue("");
      setPorterForces({});
      setCatandSpend({});
      setMarketImplications({});
      setTopMovementsAnalysis({});
      setTopCardCommentary({});
      setShowPersonas(false);

      try {
        // If categories are passed, add them to the formData
        if (event.categories && event.categories.length > 0) {
          formData.append(
            "selected_categories",
            JSON.stringify(event.categories)
          );
        }
        console.log("formData final", formData);
        setSupplierProData("");
        setCostStructureMovements([]);
        setErrorMessage(null); // Clear any previous error messages
        setUploadError(null);
        setErrorDetailsOpen(false);
        setProgress((prev) => ({ ...prev, companyDetails: true }));
        const uploadResponse = await axios.post(
          `${BACKEND_BASE_URL}/upload_SD`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        setProgress((prev) => ({ ...prev, spendPatterns: true }));
        const filename = uploadResponse.data.filename;
        setFilename(filename);

        console.log("final roleTitle", event.roleTitle);

        if (event.roleTitle && event.roleTitle === "Category Manager") {
          const clientNamesResponseQ = await axios.get(
            `${BACKEND_BASE_URL}/get_client_names?filename=${filename}`
          );
          setClientNames(clientNamesResponseQ.data);

          setActiveSection("analytics");

          axios
            .get(
              `${BACKEND_BASE_URL}/get_spend_summary?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setSpendSummary(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_summary?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCategorySummary(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_summary?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setSupplierSummary(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_chart?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCategoryChartData(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_chart_l1?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCategoryChartDataL1(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_insights_getTop3categories_CategorySpend_and_TopContributors?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              const {
                top3Categories,
                translated_CategorySpend_and_TopContributors_json,
              } = response.data;
              setTopCategories(top3Categories);
              setTopContributors(
                translated_CategorySpend_and_TopContributors_json
              );
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_insights_CostStructure?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCategoryDict(response.data.cost_structure);
              setCostStructure(response.data.cost_structure_string);
              setCsSrc(response.data.source);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_insights_TopCategorySuppliers?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setTopSuppliers(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_news?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCategoryNews(response.data.news);
              setIndiSummaries(response.data.summaries);
              setGlobalSummaries(response.data.global_summary);
              // console.log(
              //   "category cs summary",
              //   response.data.cost_structure_summary
              // );
              console.log("Full news response:", response.data);
              console.log("news response is ", response.data.news);
              console.log(
                "global summ response is",
                response.data.global_summary
              );
              console.log("indi response is", response.data.summaries);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_porter_forces?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setPorterForces(response.data.five_forces);
              setMarketImplications(response.data.market_implications);
              setCatandSpend(response.data.category_and_spend);
              console.log("Porter forces response is", response.data);
            });

          // axios
          //   .get(
          //     `${BACKEND_BASE_URL}/get_filter_series?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
          //       event.categories || []
          //     )}`
          //   )
          //   .then((response) => {
          //     setFilteredResults(response.data);
          //     setCostStructureMovements(response.data.cost_structure_movements);
          //     setTopMovementsAnalysis(response.data.top_movements_analysis);
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });

          axios
            .get(
              `${BACKEND_BASE_URL}/carbon_table?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setCarbonTable(response.data);
            });

          // // axios
          // //   .get(
          // //     `${BACKEND_BASE_URL}/get_top10_category_news_cat1?filename=${filename}`
          // //   )
          // //   .then((response) => {
          // //     setCategoryPart1Response(response.data);
          // //   });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_chart?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              setSupplierChartData(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_insights_SupplierDetailsandProducts?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((response) => {
              const {
                translated_SupplierDetailsandProducts_json,
                top3SuppliersPerCategory,
              } = response.data;
              // setTop3CategoriesSup(top3Categories)
              setTop3CategoriesSup(top3SuppliersPerCategory);
              setSupDandP(translated_SupplierDetailsandProducts_json);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/dnb_data?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((dnbresponse) => {
              const dataRisk = dnbresponse.data.supplier_risk_data;
              // Initialize variables for risk scores and score commentary
              const fetchedRiskScores = {};
              const fetchedScoreCommentary = {};

              // Populate state variables with data
              if (dataRisk) {
                for (const [supplier, data] of Object.entries(dataRisk)) {
                  if (data && typeof data === "object") {
                    fetchedRiskScores[supplier] = data;
                    fetchedScoreCommentary[supplier] =
                      data.score_commentary !== undefined
                        ? data.score_commentary
                        : null;
                  }
                }
              }

              setRiskScore(fetchedRiskScores);
              setScoreCommentary(fetchedScoreCommentary);

              const dataRevenue = dnbresponse.data.supplier_revenue_data;
              const fetchedRevenue = {};

              if (dataRevenue) {
                for (const [supplier, data] of Object.entries(dataRevenue)) {
                  if (data && typeof data === "object") {
                    fetchedRevenue[supplier] = data;
                  }
                }
              }

              setRevenue(fetchedRevenue);
              setTopCardCommentary(dnbresponse.data.top_card_summary);
              console.log("rev from be is", fetchedRevenue);
              console.log("risk from be is", fetchedScoreCommentary);
            })
            .catch((error) => {
              console.error("Error fetching supplier data:", error);
            });

          // // axios
          // //   .get(`${BACKEND_BASE_URL}/get_supplier_match?filename=${filename}`)
          // //   .then((response) => {
          // //     setSupplierProData(response.data);
          // //   });

          // // axios
          // //   .get(
          // //     `${BACKEND_BASE_URL}/get_top10_supplier_kpdbData?filename=${filename}`
          // //   )
          // //   .then((response) => {
          // //     setKpdbData(response.data);
          // //   });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_news?filename=${filename}&roleTitle=${roleTitle}&selected_categories=${JSON.stringify(
                event.categories || []
              )}`
            )
            .then((supplierNewsResponse) => {
              setSupplierNews(supplierNewsResponse.data);
            });
        } else if (
          event.roleTitle &&
          event.roleTitle === "Chief Procurement Officer"
        ) {
          const clientNamesResponseQ = await axios.get(
            `${BACKEND_BASE_URL}/get_client_names?filename=${filename}`
          );
          setClientNames(clientNamesResponseQ.data);
          console.log("Client names response is", clientNamesResponseQ.data);
          setActiveSection("analytics");

          axios
            .get(
              `${BACKEND_BASE_URL}/get_spend_summary?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setSpendSummary(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_summary?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setCategorySummary(response.data);
              console.log("Category summary response is", response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_summary?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setSupplierSummary(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_chart?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setCategoryChartData(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_chart_l1?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setCategoryChartDataL1(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_heatmap_chart?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setHeatmapChartData(response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_filter_series?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setFilteredResults(response.data);
              setCostStructureMovements(response.data.cost_structure_movements);
              setTopMovementsAnalysis(response.data.top_movements_analysis);
            })

            .catch((err) => {
              console.log(err);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_category_news?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}
            `
            )
            .then((response) => {
              setCategoryNews(response.data.news);
              setIndiSummaries(response.data.summaries);
              setGlobalSummaries(response.data.global_summary);
              // console.log(
              //   "category cs summary",
              //   response.data.cost_structure_summary
              // );
              console.log("Full news response:", response.data);
              console.log("news response is ", response.data.news);
              console.log(
                "global summ response is",
                response.data.global_summary
              );
              console.log("indi response is", response.data.summaries);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_chart?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              setSupplierChartData(response.data);
              console.log("supplier chart is", response.data);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/get_supplier_insights_SupplierDetailsandProducts?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((response) => {
              const {
                translated_SupplierDetailsandProducts_json,
                top3SuppliersPerCategory,
              } = response.data;
              // setTop3CategoriesSup(top3Categories)
              setTop3CategoriesSup(top3SuppliersPerCategory);
              setSupDandP(translated_SupplierDetailsandProducts_json);
            });

          axios
            .get(
              `${BACKEND_BASE_URL}/dnb_data?filename=${filename}&roleTitle=${
                event.roleTitle
              }&selected_categories=${JSON.stringify(event.categories || [])}`
            )
            .then((dnbresponse) => {
              const dataRisk = dnbresponse.data.supplier_risk_data;
              // Initialize variables for risk scores and score commentary
              const fetchedRiskScores = {};
              const fetchedScoreCommentary = {};

              // Populate state variables with data
              if (dataRisk) {
                for (const [supplier, data] of Object.entries(dataRisk)) {
                  if (data && typeof data === "object") {
                    fetchedRiskScores[supplier] = data;
                    fetchedScoreCommentary[supplier] =
                      data.score_commentary !== undefined
                        ? data.score_commentary
                        : null;
                  }
                }
              }

              setRiskScore(fetchedRiskScores);
              setScoreCommentary(fetchedScoreCommentary);

              const dataRevenue = dnbresponse.data.supplier_revenue_data;
              const fetchedRevenue = {};

              if (dataRevenue) {
                for (const [supplier, data] of Object.entries(dataRevenue)) {
                  if (data && typeof data === "object") {
                    fetchedRevenue[supplier] = data;
                  }
                }
              }

              setRevenue(fetchedRevenue);
              setTopCardCommentary(dnbresponse.data.top_card_summary);
              console.log("rev from be is", fetchedRevenue);
              console.log("risk from be is", fetchedScoreCommentary);
            })
            .catch((error) => {
              console.error("Error fetching supplier data:", error);
            });

          await axios
            .get(`${BACKEND_BASE_URL}/carbon_emissions?filename=${filename}`)
            .then((response) => {
              const data = response.data;
              // Extracting the main keys and total_emissions in the frontend
              const extractedData = Object.entries(data).map(
                ([key, value]) => ({
                  name: key,
                  order_amount_sum: value.order_amount_sum,
                  total_emissions: value.total_emissions,
                })
              );

              setCarbonEmission(extractedData);
            });
        }
      } catch (error) {
        console.error("Error processing file:", error);
        // alert("Error processing file. Please try again.");
        setLoading(false);
        const payload = error?.response?.data;
        if (payload) {
          if (payload.error_code) {
            setUploadError(payload);
            setErrorDetailsOpen(
              payload.error_code === "MISSING_MANDATORY_COLUMNS"
            );
            if (payload.error_code === "FILE_UNCATEGORIZED") {
              setErrorMessage("File Uncategorized");
            } else {
              setErrorMessage(
                payload.message || payload.error || "Upload failed"
              );
            }
          } else if (payload.error) {
            setUploadError(null);
            setErrorDetailsOpen(false);
            if (
              payload.error === "Missing required columns" &&
              payload.missing_columns
            ) {
              const missingColumns = payload.missing_columns.join(", ");
              setErrorMessage(`Missing required columns - ${missingColumns}`);
            } else {
              setErrorMessage(payload.error);
            }
          } else if (payload.message) {
            setUploadError(null);
            setErrorDetailsOpen(false);
            setErrorMessage(payload.message);
          } else {
            setUploadError(null);
            setErrorDetailsOpen(false);
            setErrorMessage("Upload failed. Please try again.");
          }
        } else {
          setUploadError(null);
          setErrorDetailsOpen(false);
          setErrorMessage("An unexpected error occurred. Please try again.");
        }
      } finally {
        // Clear states or perform any cleanup actions
        // setSelectedFile(null);
        // setFile(null);
        setLoading(false);
      }
    } else {
      alert("Please upload a CSV file");
    }
  };

  const handleFileChange = (event) => {
    setErrorMessage(null); // Clear any previous error messages
    setUploadError(null);
    setErrorDetailsOpen(false);
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleDownloadSampleFile = () => {
    window.location.href =
      "https://kpsgptstorageaccount.blob.core.windows.net/rapidinsights/SD/Sample.csv";
    // axios({
    //   url: "https://kpsgptstorageaccount.blob.core.windows.net/rapidinsights/SD/Dawn_Foods.csv", // Your Flask route
    //   method: "GET",
    //   responseType: "blob", // Important for downloading files
    // })
    //   .then((response) => {
    //     // Create a URL for the file
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "Sample File - Magic Cube.csv"); // Specify the file name
    //     document.body.appendChild(link);
    //     link.click();
    //   })
    //   .catch((error) => {
    //     console.error("Error downloading the file:", error);
    //   });
  };

  // Assuming you have a form, prevent the default form submission behavior
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const [categories, setCategories] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleCategoriesSelect = (newCategories) => {
    console.log("Parent received categories:", newCategories);
    setSelectedCategories(newCategories);
  };

  const handleL2Category = async (acceptedFiles, roleTitle) => {
    const filename = acceptedFiles;
    console.log("Filename is", filename);
    setSelectedFile(filename);
    setOpen(false);
    // setShowPersonas(false);

    if (roleTitle && roleTitle === "Category Manager") {
      try {
        const formData = new FormData();
        formData.append("filename", filename);

        console.log("file sent to backend is", filename);

        const response = await axios.post(
          `${BACKEND_BASE_URL}/get_topl2_categories`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        const categoriesData = response.data.categories; // Expecting a dict from backend
        setCategories(categoriesData);
        setRoleTitle(roleTitle);

        console.log("Top 10 L2 Categories:", categoriesData);
      } catch (error) {
        console.error("Error getting categories:", error);
      } finally {
        setShowPersonas(false);
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: async (acceptedFiles) => {
      const filename = acceptedFiles[0];
      setSelectedFile(filename);
      setOpen(false);
    },
    multiple: false,
    accept: [".csv"],
  });

  const SlidingContent = ({ slides, loading }) => {
    const [slideIndex, setSlideIndex] = useState(0);
    const [slideDirection, setSlideDirection] = useState("left");

    useEffect(() => {
      if (loading) {
        const interval = setInterval(() => {
          setSlideDirection((prev) => (prev === "left" ? "right" : "left"));
          setSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, 3000);
        return () => clearInterval(interval);
      }
    }, [loading, slides.length]);

    return (
      <Box>
        <Box
          sx={{
            background: "purple",
            padding: "16px",
            borderRadius: "8px",
            maxWidth: "100%",
            height: "60px",
            display: "flex",
            alignItems: "center",
            color: "white",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Slide in={loading} direction={slideDirection} timeout={500}>
            <Box display="flex" alignItems="center">
              {slides[slideIndex].icon}
              <Typography
                variant="subtitle1"
                sx={{ color: "white", marginLeft: "8px" }}
              >
                {slides[slideIndex].text}
              </Typography>
            </Box>
          </Slide>
        </Box>
        <Box display="flex" justifyContent="center" mt={2}>
          {slides.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: index === slideIndex ? "#A0186A" : "white", // Use the specified color for both active and inactive states
                borderRadius: "50%",
                margin: "0 4px",
              }}
            />
          ))}
        </Box>
      </Box>
    );
  };

  const [openModal, setOpenModal] = useState(false);

  const handleGenerate = (categories, roleTitle) => {
    console.log("Selected categories by user:", categories);
    if (selectedFile) {
      if (roleTitle === "Category Manager") {
        handleL2Category(selectedFile, roleTitle);
      } else {
        setLoading(true);
        handleFileUpload({
          target: { files: [selectedFile] },
          categories: categories,
          roleTitle: roleTitle,
        });
      }
      setCategories({});
    }
  };

  const Personas = ({ selectedFile }) => {
    const navigate = useNavigate();
    const [selectedBox, setSelectedBox] = useState(null);
    const [hoveredBox, setHoveredBox] = useState(null);

    const uploadBoxes = [
      {
        id: 1,
        icon: CPO,
        label: "Chief Procurement Officer",
        description: "Supported formats: .txt, .docx",
      },
      {
        id: 2,
        icon: CM,
        label: "Category Manager",
        description: "Supported formats: .pdf",
      },
      // Add more configurations here as needed
    ];
    return (
      <Box
        sx={{
          display: "flex",
          backgroundImage: `url(${bgsd})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* Logo */}
        <Box sx={{ marginBottom: "20px" }}>
          <img src={Logo} alt="Logo" style={{ width: "200px" }} />
        </Box>

        {/* Centered Step Box */}
        <Box
          sx={{
            backgroundColor: "#FFFFFF0F",
            border: "1px solid #FFFFFF1A",
            borderRadius: "16px",
            padding: "24px",
            width: "100%",
            maxWidth: "400px",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              color: "#8b8b8b",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Step 2 of 2
          </Typography>
          <Typography
            //   variant="h5"
            sx={{
              fontStyle: "Inter",
              fontWeight: 600,
              fontSize: "20px",
              letterSpacing: "0.4px",
              lineHeight: "28px",
              color: "white",
            }}
          >
            Choose your role
          </Typography>

          <Typography
            sx={{
              fontStyle: "Inter",
              fontWeight: 400,
              fontSize: "12px",
              letterSpacing: "0px",
              lineHeight: "20px",
              color: "#FFFFFF99",
              marginBottom: "20px",
            }}
          >
            Select a persona that suits your role at the company the best
          </Typography>

          {/* Upload Box */}
          {/* Dynamically Render Upload Boxes */}
          {uploadBoxes.map((box) => (
            <Box
              key={box.id}
              onClick={() => setSelectedBox(box.id)}
              onMouseEnter={() => setHoveredBox(box.id)}
              onMouseLeave={() => setHoveredBox(null)}
              sx={{
                border: `1px solid ${
                  selectedBox === box.id
                    ? "#E193FC"
                    : hoveredBox === box.id && selectedBox !== box.id
                    ? "#E193FC"
                    : "#FFFFFF1F"
                }`,
                borderRadius: "12px",
                padding: "20px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                position: "relative", // Add this for proper checkmark positioning
                justifyContent: "left",
                marginBottom: "10px",
                cursor: "pointer",
                width: "352px",
                height: "72px",
              }}
            >
              <img
                src={box.icon}
                alt="Logo"
                style={{ width: "40px", height: "40px", marginRight: "8px" }}
              />
              <Typography
                sx={{
                  color: "#FFFFFFE5",
                  fontSize: "16px",
                  fontWeight: 600,
                  font: "Inter",
                  textAlign: "center",
                  gap: "4px",
                }}
              >
                {box.label}
              </Typography>
              {selectedBox === box.id && (
                <RadioButtonChecked
                  checked={true}
                  sx={{
                    position: "absolute",
                    right: 20,
                    color: "#E193FC", // unchecked color
                    "&.Mui-checked": {
                      color: "#E193FC", // checked color
                    },
                  }}
                />
              )}
            </Box>
          ))}
          {/* Confirm Button */}
          {selectedBox && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Box
                component="button"
                sx={{
                  background:
                    "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                  color: "#000000",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px",
                  fontSize: "16px",
                  fontWeight: 600,
                  cursor: "pointer",
                  width: "352px",
                  height: "48px",
                  color: "#FFFFFF",
                  font: "Inter",
                  fontWeight: 600,
                  fontSize: "14px",
                  // '&:hover': {
                  //   backgroundColor: '#d17ee8',
                  // },
                }}
                onClick={() => {
                  const roleTitle = uploadBoxes.find(
                    (box) => box.id === selectedBox
                  )?.label;
                  console.log(roleTitle); // Debugging output
                  handleGenerate(selectedCategories, roleTitle);
                  if (roleTitle === "Category Manager") {
                    setOpenModal(true);
                  }

                  // // If you're using React state, update it using a state setter
                  // setState(prevState => ({
                  //   ...prevState,
                  //   roleTitle,
                  // }));
                }}
              >
                Confirm
              </Box>
            </Box>
          )}

          {selectedCategories &&
            selectedCategories.length === 0 &&
            openModal && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                  marginTop: "40px",
                }}
              >
                <CircularProgress
                  size={20} // Added size prop to make the icon smaller
                  sx={{
                    color: "white",
                    marginRight: "10px", // Added margin-right instead of margin-bottom
                  }}
                />
                <Typography
                  sx={{
                    color: "white",
                    textAlign: "center",
                    fontStyle: "Inter",
                    fontSize: "14px",
                  }}
                >
                  Fetching top categories
                </Typography>
              </Box>
            )}
        </Box>
      </Box>
    );
  };

  const UploadSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const [categorizationComplete, setCategorizationComplete] = useState(false);
    const [categorizedFile, setCategorizedFile] = useState(null);
    const [loadingMessage, setLoadingMessage] = useState("");

    const [expanded, setExpanded] = useState(false);

    const toggleExpand = () => {
      setExpanded(!expanded);
    };

    // Sample instructions data
    const instructions = [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
      // 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      // 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      // 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      // 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      // 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
    ];

    const didYouKnowTexts = [
      "We established our first overseas office in Germany in 1964",
      "Kearney is now more than 5,700 people strong, with more than 25,000 people in our alumni network",
      "Newsweek identified Kearney as one of America's Greatest Workplaces for Diversity 2023",
      "Kearney is the first consulting firm with SBTi-approved emissions targets, and became carbon neutral in 2010",
      "KOS was founded in 2021 and has grown 5x since its inception",
      "Over 60+ KPS digital asset deployments have been completed in various projects",
      "KPS is expanding beyond sourcing to broader operations and will rebrand as KOS (Kearney Operations Systems)",
    ];
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSlide(
          (prevSlide) => (prevSlide + 1) % didYouKnowTexts.length
        );
      }, 2000); // Change slide every 3 seconds

      return () => clearInterval(interval); // Cleanup interval on component unmount
    }, [didYouKnowTexts.length]);

    if (showPersonas) {
      return <Personas selectedFile={selectedFile} />;
    }

    const handleProcessTaxonomy = async () => {
      if (!selectedFile || !taxonomyFile) {
        setErrorMessage("Please upload both data and taxonomy files");
        return;
      }

      const formData = new FormData();
      formData.append("dataFile", selectedFile);
      formData.append("taxonomyFile", taxonomyFile);

      try {
        setLoading(true);
        setLoadingMessage("Categorizing data"); // Add this state variable

        const response = await axios.post(
          `${BACKEND_BASE_URL}/process_taxonomy`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            responseType: "blob",
          }
        );

        // Create a new file object from the response blob
        const categorizedFile = new File(
          [response.data],
          "Dada_Taxonomy_Categorized.xlsx",
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );

        setCategorizedFile(categorizedFile);
        setCategorizationComplete(true);
      } catch (error) {
        setErrorMessage(
          error.response?.data?.message || "Failed to process files"
        );
      } finally {
        setLoading(false);
      }
    };

    // Add this function to your component
    const openFilePicker = async () => {
      try {
        const [fileHandle] = await window.showOpenFilePicker();
        const file = await fileHandle.getFile();
        setTaxonomyFile(file);
      } catch (err) {
        console.error("Error selecting file:", err);
      }
    };

    // In your file upload modal component or handler
    const handleFileSelect = (files) => {
      if (isUncategorized) {
        // If we're uploading a taxonomy file
        handleTaxonomyUpload(files[0]);
      } else {
        // Normal file upload
        handleFileUpload({ target: { files } });
      }
      setOpen(false); // Close the modal
    };

    // Make sure handleTaxonomyUpload properly sets the file
    const handleTaxonomyUpload = (file) => {
      setTaxonomyFile(file);
      setErrorMessage(null);
      // You might need to add this to force a re-render or update
      setUploadError(null);
      setErrorDetailsOpen(false);
      console.log("Taxonomy file uploaded:", file.name);
    };

    const handleCheckCategorization = async ({ selectedFile }) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const uploadResponse = await axios.post(
          `${BACKEND_BASE_URL}/upload_SD`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        // If successful (status 200), show personas
        setShowPersonas(true);
      } catch (error) {
        // If backend sends error with 400 status
        const payload = error?.response?.data;
        if (
          payload?.error_code === "FILE_UNCATEGORIZED" ||
          payload?.error === "File Uncategorized"
        ) {
          setUploadError(payload || null);
          setErrorMessage("File Uncategorized");
        } else {
          if (payload) {
            setUploadError(payload);
            setErrorMessage(
              payload.message || payload.error || "Upload failed"
            );
          }

          console.error("Unexpected error during upload", error);
          // handle other errors if needed
        }
      }
      setLoading(false);
    };

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px",
          // zIndex: 10000,
        }}
      >
        {categories && Object.keys(categories).length > 0 && !loading && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "75vh",
                padding: "20px",
                width: "120%",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  marginBottom: "30px",
                  fontSize: "28px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                <img src={Logo} style={{ width: "200px" }} />
              </Typography>

              <Box
                sx={{
                  backgroundColor: "#FFFFFF0F",
                  border: "1px solid #FFFFFF1A",
                  borderRadius: "16px",
                  padding: "24px",
                  width: "100%",
                  maxWidth: "400px",
                }}
              >
                {/* <Typography
                    sx={{
                      color: "#8b8b8b",
                      marginBottom: "10px",
                      fontSize: "12px",
                    }}
                  >
                    Step 2 of 2
                  </Typography> */}

                {categorizationComplete && categorizedFile && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "75vh",
                      padding: "20px",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        color: "white",
                        marginBottom: "30px",
                        fontSize: "28px",
                        fontWeight: 600,
                        textAlign: "center",
                      }}
                    >
                      <img src={Logo} style={{ width: "200px" }} />
                    </Typography>

                    <Box
                      sx={{
                        backgroundColor: "#FFFFFF0F",
                        border: "1px solid #FFFFFF1A",
                        borderRadius: "16px",
                        padding: "24px",
                        width: "120%",
                        maxWidth: "400px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          color: "white",
                          marginBottom: "10px",
                          fontSize: "28px",
                          fontWeight: 600,
                        }}
                      >
                        Categorization completed
                      </Typography>

                      <Typography
                        sx={{
                          color: "white",
                          opacity: 0.7,
                          marginBottom: "30px",
                          fontSize: "16px",
                        }}
                      >
                        Your data has been successfully categorized. You can now
                        proceed or download the file for future reference.
                      </Typography>

                      <Box
                        sx={{
                          background: "#FFFFFF0F",
                          border: "1px solid #EAECF01F",
                          borderRadius: "7px",
                          padding: "15px",
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "24px",
                        }}
                      >
                        <Box sx={{ marginRight: "16px" }}>
                          <img
                            src={require("../../assets/xlsx.png")}
                            alt="XLSX Icon"
                            style={{ height: "48px" }}
                          />
                        </Box>
                        <Box>
                          <Typography sx={{ color: "white", fontSize: "16px" }}>
                            {categorizedFile.name}
                          </Typography>
                          <Typography
                            sx={{ color: "#8b8b8b", fontSize: "14px" }}
                          >
                            {(categorizedFile.size / (1024 * 1024)).toFixed(2)}{" "}
                            MB
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", gap: "16px" }}>
                        <Button
                          startIcon={<FileDownload />}
                          variant="outlined"
                          sx={{
                            color: "white",
                            borderColor: "white",
                            textTransform: "none",
                            borderRadius: "12px",
                            flex: 1,
                            height: "46px",
                          }}
                          onClick={() => {
                            const url = URL.createObjectURL(categorizedFile);
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = categorizedFile.name;
                            a.click();
                          }}
                        >
                          Download File
                        </Button>

                        <Button
                          startIcon={<AutoAwesome />}
                          variant="contained"
                          sx={{
                            background:
                              "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                            borderRadius: "12px",
                            color: "white",
                            textTransform: "none",
                            flex: 1,
                            height: "46px",
                          }}
                          onClick={() => {
                            // Use the categorized file to generate dashboard
                            handleFileUpload({
                              target: { files: [categorizedFile] },
                              categories: selectedCategories,
                              roleTitle: roleTitle,
                            });
                          }}
                        >
                          Generate
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
                {categories && Object.keys(categories).length > 0 && (
                  <CategorySelector
                    categories={categories}
                    selectedCategories={selectedCategories} // Pass selected categories as prop
                    onCategoriesSelect={handleCategoriesSelect}
                  />
                )}

                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    if (selectedFile && taxonomyFile) {
                      console.log("taxonomy file is", taxonomyFile);
                      // handleGenerateTaxonomy(); // New method for handling taxonomy file generation
                    } else if (
                      selectedFile &&
                      !taxonomyFile &&
                      isUncategorized
                    ) {
                      setOpen(true);
                    } else if (selectedFile) {
                      console.log("RT inside is", roleTitle);
                      setLoading(true);
                      handleFileUpload({
                        target: { files: [selectedFile] },
                        categories: selectedCategories,
                        roleTitle: roleTitle,
                      }); // Passing selected categories
                    } else {
                      setOpen(true); // Open file upload
                    }
                  }}
                  disabled={selectedFile && selectedCategories.length === 0} // Disable condition
                  startIcon={selectedFile ? <AutoAwesome /> : null}
                  sx={{
                    background:
                      "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                    borderRadius: "12px",
                    color: "white",
                    // marginBottom: "5px",
                    textTransform: "none",
                    height: "46px",
                  }}
                >
                  {selectedFile && !taxonomyFile && isUncategorized
                    ? "Upload Taxonomy"
                    : selectedFile && taxonomyFile
                    ? "Generate"
                    : selectedFile
                    ? "Generate"
                    : "Upload data"}
                </Button>
              </Box>
            </Box>
          </>
        )}
        {/* UPLOAD BOX */}
        {/* Upload Box - Only show when categories is empty */}
        {!loading && (!categories || Object.keys(categories).length === 0) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "75vh",
              padding: "20px",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "white",
                marginBottom: "30px",
                fontSize: "28px",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              <img src={Logo} style={{ width: "200px" }} />
            </Typography>

            <Box
              sx={{
                backgroundColor: "#FFFFFF0F",
                border: "1px solid #FFFFFF1A",
                borderRadius: "16px",
                padding: "24px",
                width: "120%",
                maxWidth: "400px",
              }}
            >
              <Typography
                sx={{
                  color: "#8b8b8b",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                Step 1 of 2
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: "white",
                  marginBottom: "30px",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                {isUncategorized ? (
                  <>
                    <>Uncategorized spend data detected</>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        color: "#FFFFFF99",
                        marginTop: "12px",
                      }}
                    >
                      Looks like the uploaded file is not categorized. Please
                      upload your taxonomy to categorize the spend.
                    </p>
                  </>
                ) : (
                  <>
                    <Typography
                      sx={{
                        fontStyle: "Inter",
                        fontWeight: 600,
                        fontSize: "20px",
                        letterSpacing: "0.4px",
                        lineHeight: "28px",
                      }}
                    >
                      Upload your data
                    </Typography>
                    <Typography
                      sx={{
                        fontStyle: "Inter",
                        fontWeight: 400,
                        fontSize: "12px",
                        letterSpacing: "0px",
                        lineHeight: "20px",
                        color: "#FFFFFF99",
                      }}
                    >
                      File format should be {ALLOWED_FILE_FORMATS.join(", ")}
                    </Typography>
                  </>
                )}
              </Typography>

              {!selectedFile ? (
                <Box
                  sx={{
                    border: "1px dashed #FFFFFF1F",
                    borderRadius: "12px",
                    padding: "30px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => setOpen(true)}
                >
                  <img
                    src={uploadicon}
                    sx={{
                      // color: "#8b8b8b",
                      // fontSize: 40,
                      marginBottom: "10px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontStyle: "Inter",
                      marginTop: "4px",
                      color: "white",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: 600,
                    }}
                  >
                    Drag & drop your files here
                  </Typography>
                </Box>
              ) : (
                <>
                  {!isUncategorized && (
                    <Box
                      sx={{
                        background: "#FFFFFF0F",
                        border: "1px solid #EAECF01F",
                        borderRadius: "7px",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "7px",
                          padding: "10px",
                          marginRight: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "7px",
                            padding: "10px",
                            marginRight: "10px",
                          }}
                        >
                          <img
                            src={require(`../../assets/${
                              selectedFile.type.includes("csv") ? "csv" : "xlsx"
                            }.png`)}
                            alt="Icon"
                            style={{
                              height: "34px",
                            }}
                          />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box>
                            <Typography
                              sx={{ color: "white", fontSize: "14px" }}
                            >
                              {selectedFile.name}
                            </Typography>
                            <Typography
                              sx={{ color: "#8b8b8b", fontSize: "12px" }}
                            >
                              {(selectedFile.size / (1024 * 1024)).toFixed(2)}{" "}
                              MB
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Delete
                        sx={{
                          color: "#8b8b8b",
                          cursor: "pointer",
                          marginTop: "-18px",
                        }}
                        onClick={() => {
                          setSelectedFile(null); // First function
                          setErrorMessage(null);
                          setUploadError(null);
                          setErrorDetailsOpen(false);
                        }}
                      />
                    </Box>
                  )}
                  {taxonomyFile && (
                    <Box
                      sx={{
                        background: "#FFFFFF0F",
                        border: "1px solid #EAECF01F",
                        borderRadius: "7px",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "7px",
                          padding: "10px",
                          marginRight: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "7px",
                            padding: "10px",
                            marginRight: "10px",
                          }}
                        >
                          <img
                            src={require(`../../assets/${
                              selectedFile.type.includes("csv") ? "csv" : "xlsx"
                            }.png`)}
                            alt="Icon"
                            style={{
                              height: "34px",
                            }}
                          />
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box>
                            <Typography sx={{ color: "white" }}>
                              {taxonomyFile.name}
                            </Typography>
                            <Typography sx={{ color: "#8b8b8b" }}>
                              {(taxonomyFile.size / (1024 * 1024)).toFixed(2)}{" "}
                              MB
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Delete
                        sx={{
                          color: "#8b8b8b",
                          cursor: "pointer",
                          marginTop: "-18px",
                        }}
                        onClick={() => {
                          setTaxonomyFile(null); // First function
                          setErrorMessage(null);
                          setUploadError(null);
                          setErrorDetailsOpen(false);
                        }}
                      />
                    </Box>
                  )}

                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={
                      selectedFile && !isUncategorized ? (
                        <NavigateNext sx={{ marginRight: "-5px" }} />
                      ) : null
                    }
                    sx={{
                      background:
                        "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                      borderRadius: "12px",
                      color: "white",
                      marginBottom: "20px",
                      textTransform: "none",
                      fontStyle: "Inter",
                      fontWeight: 600,
                      height: "46px",
                    }}
                    onClick={() => {
                      if (selectedFile && taxonomyFile) {
                        // Change to call the API function instead
                        handleProcessTaxonomy();
                      } else if (
                        selectedFile &&
                        !taxonomyFile &&
                        isUncategorized
                      ) {
                        openFilePicker();
                      } else if (selectedFile) {
                        handleCheckCategorization({ selectedFile });
                      } else {
                        setOpen(true);
                      }
                    }}
                  >
                    {selectedFile && taxonomyFile && isUncategorized
                      ? "Proceed"
                      : isUncategorized
                      ? "Upload Taxonomy"
                      : "Next"}
                  </Button>
                </>
              )}
              {(uploadError || errorMessage) && !isUncategorized && (
                <Box
                  sx={{
                    mt: 2,
                    mb: 2,
                    p: 2,
                    borderRadius: "12px",
                    border: "1px solid rgba(255, 107, 107, 0.25)",
                    backgroundColor: "rgba(255, 255, 255, 0.06)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ReportProblem sx={{ fontSize: 18, color: "#FF6B6B" }} />
                      <Typography
                        sx={{
                          color: "white",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: 1.2,
                        }}
                      >
                        {uploadError?.error || "Upload error"}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setErrorMessage(null);
                        setUploadError(null);
                        setErrorDetailsOpen(false);
                      }}
                      sx={{ color: "#8b8b8b", mt: "-4px" }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "13px",
                      mt: 0.75,
                    }}
                  >
                    {uploadError?.message || errorMessage}
                  </Typography>

                  {uploadError?.missing_columns?.length > 0 && (
                    <Box sx={{ mt: 1.5 }}>
                      <Typography
                        sx={{
                          color: "rgba(255,255,255,0.7)",
                          fontSize: "12px",
                          mb: 1,
                        }}
                      >
                        Missing columns
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {uploadError.missing_columns.map((col) => (
                          <Chip
                            key={col}
                            size="small"
                            label={col}
                            sx={{
                              backgroundColor: "rgba(255,255,255,0.1)",
                              color: "white",
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
              {!selectedFile && (
                <Button
                  startIcon={<FileDownload />}
                  sx={{
                    color: "#8b8b8b",
                    textTransform: "none",
                    width: "100%",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                  onClick={handleDownloadSampleFile} // Attach download handler
                >
                  Download sample file
                </Button>
              )}
            </Box>

            {/* INSTRUCTIONS */}
            {/* <Box
      sx={{
        backgroundColor: '#FFFFFF0F',
        border: '1px solid #FFFFFF1A',
        borderRadius: '8px',
        p: '12px',
        mt:2,
        width: '120%',
        maxWidth: '400px',
        color: 'white',
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: expanded ? 0 : 0,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Lightbulb style={{ color: '#FB85BD', marginRight:'6px', width:'16px', height:'16px' }} />
          <Typography sx={{ fontWeight: 600, fontSize: '14px', fontStyle: 'Inter' }}>
            Instructions
          </Typography>
        </Box>
        <IconButton onClick={toggleExpand} sx={{ color: 'white' }}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List>
          {instructions.map((instruction, index) => (
            <ListItem
              key={index} 
              alignItems="flex-start" 
              sx={{ 
                display: 'flex',
                alignItems: 'flex-start',
                py: 0.5,
              }}
            >
              <Typography 
                // component="span" 
                sx={{ 
                  minWidth: '24px', 
                  // mr: 0.2 ,
                  color:'#FFFFFFCC',
                  fontWeight:500,
                  fontSize:'14px',
                  fontStyle:'Inter',
                }}
              >
                {index + 1}.
              </Typography>
              <ListItemText
                primary={instruction} 
                sx={{ 
                  m: 0,
                  '& .MuiTypography-root': {
                    color: 'white',
                    opacity: 0.8,
                    color:'#FFFFFFCC',
                    fontWeight:500,
                    fontSize:'14px',
                    fontStyle:'Inter',
                  }
                }} 
              />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box> */}
          </Box>
        )}

        {loading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "76vh",
              padding: "20px",
              minWidth: "120%",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: "white",
                marginBottom: "10px",
                fontSize: "28px",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              <img src={Logo} style={{ width: "200px" }} />
            </Typography>

            <Box
              sx={{
                backgroundColor: "#FFFFFF0F",
                border: "1px solid #FFFFFF1A",
                borderRadius: "16px",
                height: "460px",
                padding: "24px",
                width: "100%",
                maxWidth: "400px",
                display: "flex",
                flexDirection: "column",
                alignItems: "space-between",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: "white",
                  marginBottom: "10px",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                {roleTitle === "" ? "Analyzing Data" : "Generating dashboard"}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    marginBottom: "20px",
                    "& .MuiCircularProgress-circle": {
                      stroke: "url(#purpleGradient)",
                    },
                  }}
                >
                  <svg width="0" height="0">
                    <defs>
                      <linearGradient
                        id="purpleGradient"
                        gradientTransform="rotate(90)"
                      >
                        <stop offset="0%" stopColor="#BF6FE5" />
                        <stop offset="100%" stopColor="#CA698F" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress />
                </Box>
                <Typography
                  variant="body1"
                  sx={{ color: "white", textAlign: "center" }}
                >
                  {roleTitle === ""
                    ? "Analyzing Data"
                    : "Generating your dashboard"}
                </Typography>
              </Box>

              <Box
                sx={{
                  background: "#FFFFFF0F",
                  border: "1px solid #EAECF01F",
                  borderRadius: "7px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px",
                  height: "60px", // Fixed height for consistent sizing
                }}
              >
                <Info sx={{ color: "#8b8b8b", marginRight: "10px" }} />
                <Box
                  sx={{ position: "relative", width: "120%", height: "100%" }}
                >
                  {didYouKnowTexts.map((text, index) => (
                    <Fade key={index} in={currentSlide === index} timeout={500}>
                      <Typography
                        //
                        sx={{
                          color: "white",
                          position: "absolute",
                          fontSize: "12px",
                          top: 0,
                          left: 0,
                          right: 0,
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                          opacity: currentSlide === index ? 1 : 0,
                        }}
                      >
                        {text}
                      </Typography>
                    </Fade>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  // console.log("tma", topMovementsAnalysis);
  const handleNextUp = () => {
    setActiveSection("upload spend");
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          backgroundImage: `url(${bgsd})`,
          backgroundSize: "cover", // Force full coverage
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          width: "100vw", // Use viewport width
          maxWidth: "100%",
          // position: "absolute !important", // Break out of parent constraints
          // left: "0 !important",
          // top: "0 !important",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            backgroundImage: `url(${bgsd})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
          }}
        >
          {activeSection === "welcome" ? (
            <UploadSection
              // Pass necessary props here
              role={role}
              setRole={setRole}
              purpose={purpose}
              setPurpose={setPurpose}
              handleNext={handleNextUp}
              setSelectedFile={setSelectedFile}
            />
          ) : activeSection === "upload spend" ? (
            <UploadSection
              // Pass necessary props here
              onComplete={() => setActiveSection("insights")}
            />
          ) : (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ marginTop: "60px" }}>
                <SidebarFixed
                  setActiveSection={setActiveSection}
                  setShowUpload={setShowUpload}
                  roleTitle={roleTitle}
                />
              </div>
              <SpendDashboardAnalyticsSection
                roleTitle={roleTitle}
                clientNames={clientNames}
                currentSection={currentSection}
                currentSubSection={currentSubSection}
                handleBreadcrumbClick={handleBreadcrumbClick}
                spendSummary={spendSummary}
                categorySummary={categorySummary}
                supplierSummary={supplierSummary}
                top3CategoriesSup={top3CategoriesSup}
                supDandP={supDandP}
                supCustInfo={supCustInfo}
                riskScore={riskScore}
                scoreCommentary={scoreCommentary}
                revenue={revenue}
                supplierNews={supplierNews}
                supplierProData={supplierProData}
                kpdbData={kpdbData}
                topcardCommentary={topcardCommentary}
                costStructureMovements={costStructureMovements}
                topMovementsAnalysis={topMovementsAnalysis}
                porterForces={porterForces}
                supplierChartData={supplierChartData}
                globalSummaries={globalSummaries}
                indiSummaries={indiSummaries}
                filteredResults={filteredResults}
                carbonTable={carbonTable}
                carbonEmission={carbonEmission}
                marketImplications={marketImplications}
                catandSpend={catandSpend}
                csSrc={csSrc}
                categoryNews={categoryNews}
                categoryChartData={categoryChartData}
                categoryChartDataL1={categoryChartDataL1}
                topSuppliers={topSuppliers}
                demandandSupply={demandandSupply}
                costStructure={costStructure}
                categoryDict={categoryDict}
                marketSize={marketSize}
                topContributors={topContributors}
                topCategories={topCategories}
                heatmapChartData={heatmapChartData}
              />
            </div>
          )}
        </Box>
        <Dialog
          open={open}
          onClose={() => !loading && setOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.5rem" }}
          >
            Upload your files
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center", mb: 2 }}
            >
              File should be of format .csv
            </Typography>
            <Box
              {...getRootProps()}
              sx={{
                border: "2px dashed #ccc",
                borderRadius: "8px",
                p: 3,
                textAlign: "center",
                cursor: "pointer",
                bgcolor: isDragActive ? "action.hover" : "background.paper",
              }}
            >
              <input {...getInputProps()} />
              <FolderIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
              <Typography variant="body1" color="text.secondary">
                Drag & Drop your files here
              </Typography>
            </Box>

            {loading && (
              <Box className="w-full mt-4 text-center">
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div className="bg-blue-600 h-2.5 rounded-full w-full animate-pulse"></div>
                </div>
                <Typography variant="body2" className="mt-2">
                  Preparing Dashboard...
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </div>
  );
};

export default SpendDashboard;
